import React, {useState} from "react"
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import './App.css';
import LoginComponent from "./components/LoginComponent";
import HomeComponent from "./components/HomeComponent";
import UseTokenComponent from "./components/UseTokenComponent";
import HeaderComponent from "./components/HeaderComponent";
import LogoutPageComponent from "./components/LogoutPageComponent";
import RegisterComponent from "./components/RegisterComponent";

// this context tracks the params of a profile a user is in the process of creating
export const ProfileContext = React.createContext()

// this context tracks the params of a profile a user is comparing against
export const CompareContext = React.createContext()

function App() {
  const { token, removeToken, saveToken } = UseTokenComponent()

  let profileName = ""
  let flowRate = 0
  let hv = 0
  let lv = 0
  let dutyCycle = 0
  let frequency = 0

  // profileContext = [0, 1, 2, 3, 4, 5]

  const unsavedProfile = [profileName, flowRate, hv, lv, dutyCycle, frequency]

  const compareProfile = [profileName, flowRate, hv, lv, dutyCycle, frequency]


  return (
    <div >
      <BrowserRouter>
      <ProfileContext.Provider value={unsavedProfile}>
      <CompareContext.Provider value={compareProfile}>
        <HeaderComponent token={removeToken}/>
        {!token && token !== "" && token !== undefined?
        <LoginComponent saveToken={saveToken} />
        
      : (
        <>
          <Routes>
            <Route path="/" element={<HomeComponent token={token} setToken={saveToken} />}/>
            <Route path="/logout" element={<LogoutPageComponent/>} />
            <Route path="/register" element={<RegisterComponent token={token} setToken={saveToken}/>} />
          </Routes>
        </>
      )
      }
      </CompareContext.Provider>
      </ProfileContext.Provider>
      </BrowserRouter>
    </div>
  );
}

export default App;
